import { Box } from '@mui/system'
import { useMediaQuery } from '@mui/material'
import Mobile from './Mobile'
import Desktop from './Desktop'

const Index = () => {
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))

  return (
    <Box sx={styles.filterStyle}>
        {isXsScreen
          ? <Mobile />
          : <Desktop />}
    </Box>
  )
}
const styles = {
  filterStyle: {
    width: '100%',
  },
}
export default Index
